import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import axios from "axios";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Alert from "@mui/material/Alert";

// Router
import { Link, useNavigate } from "react-router-dom";
// Image
import tvc_Logo from "../photos/tvc_logo.png";
import loginCover from "../photos/login_cover.jpg";

export default function Login() {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [showPassword, setShowPassword] = useState(false);
  const [isSuccess, setisSuccess] = useState();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [isAuthenticated, setIsAuthenticated] = useState();
  const [user, setUser] = useState({ user_email: "", user_password: "" });

  const [message, setMessage] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate for redirect

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send login request to the backend
      const response = await axios.post(`${baseURL}/loginUser`, user, {
        withCredentials: true, // This enables cookies to be sent and received
      });
      setMessage(response.data.message); // Display login success message
      setisSuccess(true);
      // Save access token in memory (avoid localStorage/sessionStorage for sensitive data)

      const accessToken = response.data.accessToken;
      if (accessToken) {
        navigate(`/profile/${response.data.user.user_id}`); // Redirect to the profile page
        window.location.reload(); // Redirect to profile
      }
    } catch (error) {
      setisSuccess(false);
      // Handle error response
      if (error.response) {
        setMessage(error.response.data.error); // Display error message from backend
      } else {
        setMessage("Incorrect email or password. Please try again.");
      }
    }
  };

  const handleClick = () => {
    navigate("/");
  };

  return (
    <Box
      component="form"
      sx={{
        "& > :not(style)": {
          m: 1,
          width: "100%",
        },
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      width="100%"
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <img
        src={tvc_Logo}
        alt="The Vintage Collective"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      />
      {message == "" ? (
        ""
      ) : (
        <Alert severity={isSuccess ? "success" : "error"}>{message}</Alert>
      )}
      <TextField
        id="outlined-basic"
        label="Email"
        variant="outlined"
        value={user.email}
        onChange={(event) => {
          setUser({ ...user, user_email: event.target.value });
        }}
      />
      <TextField
        id="outlined-basic"
        label="Password"
        type={showPassword ? "text" : "password"}
        variant="outlined"
        value={user.password}
        onChange={(event) => {
          setUser({ ...user, user_password: event.target.value });
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? "hide the password" : "display the password"
                  }
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />

      <Box sx={{ textAlign: "right" }}>
        {" "}
        <Link to={"/auth/forgot-password"}>Forgot Password?</Link>
      </Box>
      <Button variant="contained" type="Submit">
        Sign in
      </Button>
      <span>
        Are you new here? <Link to={"/register"}>Sign up here!</Link>
      </span>
    </Box>
  );
}
